<template>
  <span style="position: absolute; top: 50%; right: 0px; transform: translate(0%, -50%);">
    <div>
      <f7-button
        :href="isDev"
        style="display: inline-block; min-width: 36px; padding: 0px;"
        v-show="itemAmount > 0"
        @click.stop="decrease">
        <font-awesome-icon icon="minus-circle" style="font-size: 24px;" />
      </f7-button>
      <span
        v-show="itemAmount > 0"
        style="display: inline-block;
               width: 10px;
               text-align: center;
               line-height: 24px;
               position: relative;
               top: -1px;">
        {{ itemAmount }}
      </span>
      <!-- add :href="false" to remove hash itemBucket (#) at the end of the url -->
      <f7-button
        :href="isDev"
        style="display: inline-block; min-width: 36px; padding: 0px;"
        @click.stop="increase">
        <font-awesome-icon icon="plus-circle" style="font-size: 24px;" />
      </f7-button>
    </div>
  </span>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import * as R from 'ramda'

export default {
  name: 'AmountAdjustment',
  dependencies: [
    'platformUtils',
    'themeColor'
  ],
  data () {
    return {
      isDev: process.env.NODE_ENV === 'development' ? '#' : false, // remove errors when using dev mode
      maxItem: 20,
      actionsOpen: false
    }
  },
  computed: {
    ...mapState('itemModule', [
      'cart',
      'forms',
      'questions'
    ]),
    ...mapGetters([
      'storeId',
      'currentMenu'
    ]),
    itemDefinition () {
      return this.currentMenu.items[this.id]
    },
    itemAmount () {
      return this.itemObjs === undefined ? 0 : Object.keys(this.itemObjs).length
    },
    selectedItemObjs () { // TODO simplify this
      return Object.keys(this.cart).length !== 0 ? Object.keys(this.itemObjs || {}).map(k => (this.itemObjs || {})[k]) : []
    },
    areItemsIdentical () {
      return this.selectedItemObjs.every((itemObj, _, a) => R.equals(a[0].values, itemObj.values))
    }
  },
  props: {
    id: {},
    itemObjs: Object,
    size: {
      type: Number
    }
  },
  methods: {
    decrease: function () {
      if (this.areItemsIdentical) {
        this.removeItem({
          itemBucket: 'cart',
          id: this.id,
          instanceId: this.selectedItemObjs[0].instanceId
        })
      } else {
        this.$f7router.navigate(`/stores/${this.storeId}/items/cart/${this.id}/delete-item-actions`)
      }
    },
    increase: function () {
      this.addNewItemToCart(this.id)
    },
    ...mapActions('itemModule', [
      'removeItem',
      'addNewItemToCart'
    ])
  }
}
</script>

<style lang="scss" scoped>
// .number-android {
//   transform: translate(0%, 7px);
// }
//
// .number-ios {
//   transform: translate(0%, 0px);
// }
</style>
